import { useEffect, useRef, useState } from 'react';

import { scroll } from 'utils';
import classnames from 'consts/classnames';

/**
 * @typedef  Output
 * @type {Object}
 * @property {Function} toggleFilter
 */

/**
 * @returns {Output}
 */
const useMobileFilters = () => {
    const [filterIsOpen, setFilterIsOpen] = useState(false);
    const bodyRef = useRef(null);

    const toggleFilter = () => {
        setFilterIsOpen(prevState => !prevState);
    };

    const toggleBodyFilterIsOpenClassName = () => {
        if (!bodyRef.current) {
            return;
        }

        if (filterIsOpen) {
            bodyRef.current.classList.add(classnames.FILTER_IS_OPEN);
            return;
        }

        bodyRef.current.classList.remove(classnames.FILTER_IS_OPEN);
    };

    const togglePageScroll = () => {
        if (filterIsOpen) {
            scroll.forbid();
        } else {
            scroll.restore();
        }
    };

    const handleDidMount = () => {
        bodyRef.current = document.body;
    };

    useEffect(() => {
        handleDidMount();
    }, []);

    useEffect(() => {
        toggleBodyFilterIsOpenClassName();
        togglePageScroll();
    }, [filterIsOpen]);

    return { toggleFilter };
};

export default useMobileFilters;
